package pl.michal_cyran.brand_hub.subpages.freelancing.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaIcon
import com.varabyte.kobweb.silk.components.icons.fa.IconCategory
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.IconBoxStyle
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun PlatformCard(
    title: String,
    iconName: String,
    modifier: Modifier = Modifier,
) {
    val cm = ColorMode.current.toSitePalette()

    Column(
        CardStyle.toModifier().then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        FaIcon(
            name = iconName,
            modifier = Modifier.color(cm.primary),
            style = IconCategory.SOLID
        )

        P(
            Modifier
                .fontWeight(700)
                .color(ColorMode.current.toSitePalette().textMuted)
                .toAttrs()
        ) {
            Text(
                title
            )
        }
    }
}

